import script from "./LoginForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginForm.vue?vue&type=script&lang=ts&setup=true"

import "./LoginForm.vue?vue&type=style&index=0&id=638ace45&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638ace45"]])

export default __exports__